<template>
    <div>
        <div class="flex-btwn-aic header" :style="{ backgroundColor: Bg }" >
            <span  @click="toBack()"  class="el-icon-arrow-left" :class="{ hidden: !isShowBack }"></span>
            <div><slot></slot></div>
            <span class="el-icon-arrow-left hidden"></span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        isShowBack:{ type:Boolean, default:false },
        Bg:{ type:String, default:'#ffffff' },
        backUrl:{ type:String },
    },
    methods:{
        toBack(){
            let _ = this
            // if(_.backUrl == '/home')
            console.log('_.backUrl',_.backUrl)
            if(_.backUrl=='/home' || _.backUrl == '/service'){
                _.$router.replace (_.backUrl)
                return
            }
            if(window.history.length<2){
                _.$router.push(`/home`)
            }else{
                _.$router.go(-1)
            } 
        }
    },
}
</script>

